import React from 'react'
import { connect } from 'react-redux'
import { CREATE_PROJECT_MODAL } from '@chegg-wt/core/state/modals/constants'
import { createCiteProject } from '@chegg-wt/core/state/folders/actions'
import BaseProjectModal from '../BaseProjectModal'
import { MODAL_TITLE_CREATE_CITATION_LIST } from '../BaseProjectModal/types'
import { CreateProjectModalProps } from './types'

const CreateProjectModal: React.FunctionComponent<CreateProjectModalProps> = ({
  createProject,
}) => (
  <BaseProjectModal
    name={CREATE_PROJECT_MODAL}
    confirmText="Create"
    title={MODAL_TITLE_CREATE_CITATION_LIST}
    action={createProject}
  />
)

const mapDispatchToProps = {
  createProject: (defaultStyle, name) => createCiteProject({ defaultStyle, name }),
}

export default connect(null, mapDispatchToProps)(CreateProjectModal)
